import axios from 'axios'
import store from '../store'
import Cookies from 'js-cookie'

const axiosInstance = axios.create({
    //withCredentials: true,
});
// Add a request interceptor
axiosInstance.interceptors.request.use(function (config) {
    const user = store.getters.getUser;
    const token = Cookies.get('access_token');

    if (user && token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    } else {
        delete config.headers['Authorization'];
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axiosInstance.interceptors.response.use(function (res) {
    return res;
}, function (err) {
    if (err.response.status === 401) {
        Cookies.remove('access_token');
        Cookies.remove('device_token');
        location.href = '/login';
    }
    return Promise.reject(err);
});

export default axiosInstance;
